export default __webpack_public_path__ + "static/media/learn.27cee5e3.webp";